import { useMutation, useQuery } from "@tanstack/react-query";
import apiClient from "@apis/index";
import Routes from "@apis/routes";
import { BMHResponse } from "@src/types/BMHresponse";

export const useCanRequestAgain = (
  stockItemId: number,
  requestType: string
) => {
  return useQuery({
    queryKey: ["CAN_REQUEST_AGAIN", stockItemId, requestType],
    enabled: !!requestType,
    queryFn: () =>
      apiClient.get<BMHResponse>(
        Routes.CAN_REQUEST_AGAIN(stockItemId, requestType)
      ),
  });
};

export const useStockItemRequest = () => {
  return useMutation({
    mutationFn: (data) => apiClient.post(Routes.STOCK_ITEM_REQUEST, data),
  });
};
